module.exports = __webpack_public_path__ + "premium_purchase_icon_4.png?6452c0f25074c90293a97261f5a7a5e2";


//////////////////
// WEBPACK FOOTER
// ./static/img/premium_purchase_icon_4.png
// module id = 339
// module chunks = 0